import converters from "@/converters";
import type { PlannerFilterFragment } from "@/graphql";
import type { IMultiSelectItem } from "@/interfaces";
import type { PlannerFilterItem } from "@/types";
import type { Ref } from "vue";

const toPlannerFilterItem = (
  departmentList: Ref<IMultiSelectItem[]>,
  categoryList: Ref<IMultiSelectItem[]>,
  employeeList: Ref<IMultiSelectItem[]>,
  residentList: Ref<IMultiSelectItem[]>,
  items: PlannerFilterFragment[],
): PlannerFilterItem[] => {
  return items.map((data) => {
    let user;

    if (data.user) {
      user = {
        id: data.user.id,
      };
    }

    return {
      id: data.id || "",
      title: data.title || "",
      userTypes: data.assigneeTypes || [],
      departments: converters.shared.toList(departmentList, data.departments),
      categories: converters.shared.toList(categoryList, data.categories),
      people: [
        ...converters.shared.toList(employeeList, data.employees),
        ...converters.shared.toList(residentList, data.residents),
      ],
      user,
    };
  });
};

export default {
  toPlannerFilterItem,
};
